import React from 'react';

const SvgGb = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="GB_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="GB_svg__b" fill="#fff">
        <use xlinkHref="#GB_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#GB_svg__a" />
      <path fill="#0A17A7" mask="url(#GB_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M6.674 13.333H0V6.667h6.674L-2.774.294l1.492-2.21 11.949 8.06v-7.477h6.666v7.476l11.95-8.06 1.49 2.211-9.447 6.373H28v6.666h-6.674l9.448 6.373-1.492 2.21-11.949-8.06v7.477h-6.666v-7.476l-11.95 8.06-1.49-2.211 9.447-6.373z"
        fill="#FFF"
        mask="url(#GB_svg__b)"
      />
      <path
        d="M18.668 6.332L31.333-2"
        stroke="#DB1F35"
        strokeWidth={0.667}
        strokeLinecap="round"
        mask="url(#GB_svg__b)"
      />
      <path
        d="M20.013 21.35l11.354-7.652"
        stroke="#DB1F35"
        strokeWidth={0.667}
        strokeLinecap="round"
        mask="url(#GB_svg__b)"
        transform="matrix(1 0 0 -1 0 35.048)"
      />
      <path
        d="M8.006 6.31L-3.837-1.67"
        stroke="#DB1F35"
        strokeWidth={0.667}
        strokeLinecap="round"
        mask="url(#GB_svg__b)"
      />
      <path
        d="M9.29 22.31l-13.127-8.705"
        stroke="#DB1F35"
        strokeWidth={0.667}
        strokeLinecap="round"
        mask="url(#GB_svg__b)"
        transform="matrix(1 0 0 -1 0 35.915)"
      />
      <path
        fill="#E6273E"
        mask="url(#GB_svg__b)"
        d="M0 12h12v8h4v-8h12V8H16V0h-4v8H0z"
      />
    </g>
  </svg>
);

export default SvgGb;
